import React, { useState } from 'react';
import Header from './Header';
import Footer from './Footer';
import { useLanguage } from './LanguageContext';

const TermsOfUseSinhala = () => {

    return (
        <div className="container">
            <h1>භාවිතා කිරීම් කොන්දේසි</h1>
            <p><strong>ප්‍රභාෂක දිනය:</strong> 2025 මැයි 30</p>
            <p>මෙම භාවිතා කොන්දේසි (“<strong>කොන්දේසි</strong>”) Boggler (Private) Limited (“<strong>Boggler</strong>,” “<strong>අපි</strong>,” “<strong>අපගේ</strong>” හෝ “<strong>අප</strong>”) විසින් සපයන සේවාවන්ට පිවිසීම සහ ඒවා භාවිතය පාලනය කරයි, ඒ අතර:</p>
            <ul>
                <li><strong>theboggler.com</strong> වෙබ් අඩවිය ("<strong>වෙබ්අඩවිය</strong>")</li>
                <li><strong>Buckish</strong>, <strong>Apex</strong>, සහ <strong>Third View</strong> යන ජංගම යෙදුම් (එකතුව "<strong>යෙදුම්</strong>")</li>
                <li>අපගේ දුරකථන අංක හෝ කෙටි කේත ("<strong>හොට්ලයින්</strong>") සමඟ අන්තර්ක්‍රියා කිරීම</li>
            </ul>
            <p>ඔබ වෙබ්අඩවිය, යෙදුම් හෝ හොට්ලයින් භාවිතා කිරීමෙන් මෙම කොන්දේසි පිළිගන්නා බවට එකඟ වීමට හැඳින්වේ. එකඟ නොවේනම්, කරුණාකර සේවාවන් භාවිතා නොකරන්න.</p>

            <h2>1. සුදුසුකම්</h2>
            <p>ඔබ අවම වශයෙන් වයස අවුරුදු 13ක් විය යුතුය. වයස අවුරුදු 18ට අඩු නම්, දෙමාපිය අනුමතියක් තිබිය යුතුය.</p>

            <h2>2. සේවාවන් විස්තරය</h2>
            <p>Boggler ඔබට පහත කටයුතු කිරීමට ඉඩ සලසයි:</p>
            <ul>
                <li>සඟරා පිවිසුම්, පණිවිඩ, හෝ සමාජ මාධ්‍ය පෝස්ට් වල ස්ක්‍රීන්ෂොට් උඩුගත කිරීම</li>
                <li>මාර්ගෝපදේශක ("මගපෙන්වන්නන්") තේරීම සහ ප්‍රතිපෝෂණ ලබා ගැනීම</li>
                <li>දායකවීම සහ ගෙවීම් කිරීම, ඇතුළුව මගපෙන්වීමේ විමසුම් සහ අඛණ්ඩ සහය</li>
            </ul>

            <h2>3. පරිශීලක වගකීම්</h2>
            <p>ඔබ එකඟ වන්නේ:</p>
            <ul>
                <li>සේවාවන් නීත්‍යානුකූල ලෙස භාවිතා කිරීමට</li>
                <li>නීති විරෝධී, හානිකර, හෝ අයිතිවාසිකම් කඩ කරන අන්තර්ගතයක් උඩුගත නොකිරීමට</li>
                <li>අනික් අය ලෙස පෙනී නොසිටීමට හෝ ඔබේ හැඳුනුම වැරදි ලෙස නිරූපණ නොකිරීමට</li>
                <li>අපගේ පද්ධතිය හැක් කිරීමට, බාධා කිරීමට හෝ ආපසු ඉංජිනේරු කිරීමට උත්සාහ නොකිරීමට</li>
                <li>හදිසි අවස්ථාවන් සඳහා සේවාවන් භාවිතා නොකිරීමට</li>
            </ul>
            <p>ඔබ උඩුගත කරන අන්තර්ගතය සඳහා සම්පූර්ණ වගකීම ඔබ සතුය.</p>

            <h2>4. ගෙවීම්</h2>
            <ul>
                <li><strong>ගාස්තු:</strong> Buckish, Third View සහ වෙනත් යෙදුම් සඳහා ගාස්තු අදාළ වේ.</li>
                <li><strong>සෑම විමසුමකටම ගෙවීම්:</strong> විශේෂ අයකිරීම් විය හැක.</li>
                <li><strong>තුන්වන පාර්ශව ගෙවීම් සැකසුම:</strong> Stripe, Apple Pay වැනි සේවාවන් හරහා සුරක්ෂිතව සැකසෙයි.</li>
                <li><strong>ආපසු ගෙවීම් නොමැත:</strong> නීතිය අනුව අවශ්‍ය නම් හැර.</li>
            </ul>

            <h2>5. බුද්ධිමය දේපළ</h2>
            <p>වෙබ්අඩවිය සහ යෙදුම් වල සියලු අන්තර්ගතය Boggler හි හිමිකමට පත්ය.</p>

            <h2>6. මගපෙන්වීමේ විමසුම් සහ වෘත්තීය සීමා</h2>
            <ul>
                <li>මගපෙන්වන්නන් වෘත්තීය වෛද්‍ය වරුන් නොවේ (එසේ සඳහන් නොකලහොත්)</li>
                <li>ප්‍රතිපෝෂණය අධ්‍යාපනික සහ විමසුම් පරිදි පමණි</li>
                <li>ඔබේ තීරණ සඳහා අප වගකීම් නොගනී</li>
            </ul>

            <h2>7. අවසන් කිරීම</h2>
            <p>අපට ඔබේ ප්‍රවේශය අත්හිටුවීමට හෝ අවසන් කිරීමට අයිතිය ඇත.</p>

            <h2>8. වගකීම් අහෝසි කිරීම</h2>
            <p>සේවාවන් “ඇති තත්වයෙනි” යන ආකාරයෙන් ලබාදේ.</p>

            <h2>9. වගකීම් සීමා</h2>
            <p>නීතියේ උපරිම ප්‍රමාණය තෙක් අප වගකීම් නොගනී.</p>

            <h2>10. වෙනස්කම්</h2>
            <p>අපට මේ කොන්දේසි යාවත්කාලීන කිරීමට අයිතිය ඇත.</p>

            <h2>11. අධිකරණ නීතිය</h2>
            <p>ශ්‍රී ලංකා නීතියට අනුව පාලනය කෙරේ.</p>

            <h2>12. අප අමතන්න</h2>

            <p>
                <strong>Boggler (Private) Limited</strong><br />
                272b 2/1 High Level Road<br />
                Maharagama 10280, ශ්‍රී ලංකාව<br />
                ඊමේල්: <span onClick={() => window.open("mailto:buck@theboggler.com")}>buck@theboggler.com</span>
            </p>
        </div>
    );
}

export default TermsOfUseSinhala;